import { CreateBookingInquiryEndpoint } from '@kouto/types';
import { z } from 'zod';
import { post } from '../api';
import ApiResponse from '../types/ApiResponse';

export type CreateRequestResponse = z.infer<
  typeof CreateBookingInquiryEndpoint.responseSchema
>;

export type CreateRequest = z.infer<
  typeof CreateBookingInquiryEndpoint.requestSchema
>;

const createBookingRequest = async (
  url: string,
  { brandId }: { brandId: string },
  body: CreateRequest,
) => {
  const response = await post<ApiResponse<CreateRequestResponse>>(url, {
    body: JSON.stringify(body),
    headers: {
      'Kouto-Brand-Id': brandId,
    },
  });
  return response.data;
};

export default createBookingRequest;
